export default "__VITE_ASSET__blLv3xuS__"